import { LanguagesEnum } from '../../../../config/languages';

const CONFIGURATION = {};

export const Translations = {
  payment_reference_control: {
    [LanguagesEnum.English]: 'Payment Reference',
    [LanguagesEnum.Greek]: 'Payment Reference',
  },
  payment_date_control: {
    [LanguagesEnum.English]: 'Payment Date',
    [LanguagesEnum.Greek]: 'Payment Date',
  },
  submit: {
    [LanguagesEnum.English]: 'Submit',
    [LanguagesEnum.Greek]: 'Submit',
  },
};

export default CONFIGURATION;
